import { render, staticRenderFns } from "./NewsDetailView.vue?vue&type=template&id=5cc5be91&scoped=true"
import script from "./NewsDetailView.vue?vue&type=script&lang=js"
export * from "./NewsDetailView.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailView.vue?vue&type=style&index=0&id=5cc5be91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc5be91",
  null
  
)

export default component.exports